export default [
    {
        id : 1,
        name : "Fitness Pro",
        img : require('../assets/images/wireframe (1).png'),
        screenShots : [
            require('../assets/images/screens/fitness (1).PNG'),
            require('../assets/images/screens/fitness (2).PNG'),
            require('../assets/images/screens/fitness (3).PNG'),
            require('../assets/images/screens/fitness (4).PNG'),
            require('../assets/images/screens/fitness (5).PNG')
        ],
        description : {
            theme : 'Gym store, training and diet tracking',
            target : 'Personal',
            techno : 'Html - Css - Js - Php',
            duration : '10 Days'
        }
    },
    {
        id : 2,
        name : "Hijou Voice",
        img : require('../assets/images/wireframe (2).png'),
        screenShots : [
            require('../assets/images/screens/hijouvoice (1).png'),
            require('../assets/images/screens/hijouvoice (2).png'),
            require('../assets/images/screens/hijouvoice (3).png'),
            require('../assets/images/screens/hijouvoice (4).png'),
            require('../assets/images/screens/hijouvoice (5).png')
        ],
        description : {
            theme : 'Voice over portfolio',
            target : 'Freelance',
            techno : 'Html - Css - Js',
            duration : '7 Days'
        }
    },
    {
        id : 3,
        name : "Wesourica",
        img : require('../assets/images/wireframe (17).png'),
        screenShots : [
            require('../assets/images/screens/wesourcia (1).PNG'),
            require('../assets/images/screens/wesourcia (2).PNG'),
            require('../assets/images/screens/wesourcia (3).PNG'),
            require('../assets/images/screens/wesourcia (4).PNG'),
            require('../assets/images/screens/wesourcia (5).PNG')
        ],
        description : {
            theme : 'B2B platform',
            target : 'Internship',
            techno : 'React Js - Laravel - Material Ui - Sass',
            duration : '1 Month'
        }
    },
    {
        id : 4,
        name : "Brainwave",
        img : require('../assets/images/wireframe (14).png'),
        screenShots : [
            require('../assets/images/screens/brainwave (1).PNG'),
            require('../assets/images/screens/brainwave (2).PNG'),
            require('../assets/images/screens/brainwave (3).PNG'),
            require('../assets/images/screens/brainwave (4).PNG'),
            require('../assets/images/screens/brainwave (5).PNG')
        ],
        description : {
            theme : 'Moderne ChatGPT clone website',
            target : 'Personal',
            techno : 'React Js - Material Ui - Sass',
            duration : '10 Days'
        }
    },
    {
        id : 5,
        name : "Al Manarah",
        img : require('../assets/images/wireframe (15).png'),
        screenShots : [
            require('../assets/images/screens/al manarah (1).png'),
            require('../assets/images/screens/al manarah (2).png'),
            require('../assets/images/screens/al manarah (3).png'),
            require('../assets/images/screens/al manarah (4).png'),
            require('../assets/images/screens/al manarah (5).png')
        ],
        description : {
            theme : 'Investment platform',
            target : 'Personal',
            techno : 'Laravel - Sass',
            duration : '10 Days'
        }
    },
    {
        id : 6,
        name : "Hi Group",
        img : require('../assets/images/wireframe (16).png'),
        screenShots : [
            require('../assets/images/screens/hi-group (1).PNG'),
            require('../assets/images/screens/hi-group (2).PNG'),
            require('../assets/images/screens/hi-group (3).PNG'),
            require('../assets/images/screens/hi-group (4).PNG'),
            require('../assets/images/screens/hi-group (5).PNG')
        ],
        description : {
            theme : 'ETL(extract, transform, & load) Saas',
            target : 'Internship',
            techno : 'React Js - Laravel - Material Ui - React Flow - Sass',
            duration : '2 Months'
        }
    },
    {
        id : 7,
        name : "DaniTube",
        img : require('../assets/images/wireframe (3).png'),
        screenShots : [
            require('../assets/images/screens/danitube (1).PNG'),
            require('../assets/images/screens/danitube (2).PNG'),
            require('../assets/images/screens/danitube (3).PNG'),
            require('../assets/images/screens/danitube (4).PNG'),
            require('../assets/images/screens/danitube (5).PNG')
        ],
        description : {
            theme : 'Moderne YouTube clone website',
            target : 'Personal',
            techno : 'React Js - Material Ui',
            duration : '7 Days'
        }
    },
    {
        id : 8,
        name : "TPS Delivery",
        img : require('../assets/images/wireframe (4).png'),
        screenShots : [
            require('../assets/images/screens/tpsd (1).png'),
            require('../assets/images/screens/tpsd (2).png'),
            require('../assets/images/screens/tpsd (3).png'),
            require('../assets/images/screens/tpsd (4).png'),
            require('../assets/images/screens/tpsd (5).png')
        ],
        description : {
            theme : 'Shipping address system platform from USA, China and Turkey.',
            target : 'Freelance',
            techno : 'Html - Css - Js - Php',
            duration : '30 Days'
        }
    },
    {
        id : 9,
        name : "Foodies",
        img : require('../assets/images/wireframe (5).png'),
        screenShots : [
            require('../assets/images/screens/foodies (1).PNG'),
            require('../assets/images/screens/foodies (2).PNG'),
            require('../assets/images/screens/foodies (3).PNG'),
            require('../assets/images/screens/foodies (4).PNG'),
            require('../assets/images/screens/foodies (5).PNG')
        ],
        description : {
            theme : 'Food delivery platform.',
            target : 'Personal',
            techno : 'Html - Css - Js - Php',
            duration : '20 Days'
        }
    },
    {
        id : 10,
        name : "Tarj'Man",
        img : require('../assets/images/wireframe (6).png'),
        screenShots : [
            require('../assets/images/screens/tarjman (1).png'),
            require('../assets/images/screens/tarjman (2).png'),
            require('../assets/images/screens/tarjman (3).png'),
            require('../assets/images/screens/tarjman (4).png'),
            require('../assets/images/screens/tarjman (5).png')
        ],
        description : {
            theme : 'Moderne Google Translate clone website.',
            target : 'Personal',
            techno : 'React Js - Sass',
            duration : '7 Days'
        }
    },
    {
        id : 11,
        name : "Ista RN",
        img : require('../assets/images/wireframe (7).png'),
        screenShots : [
            require('../assets/images/screens/ista (1).PNG'),
            require('../assets/images/screens/ista (2).PNG'),
            require('../assets/images/screens/ista (3).PNG'),
            require('../assets/images/screens/ista (4).PNG'),
            require('../assets/images/screens/ista (5).PNG')
        ],
        description : {
            theme : 'ISTA educational platform',
            target : 'Freelance',
            techno : 'Html - Css - Js - Php - Bootstrap',
            duration : '25 Days'
        }
    },
    {
        id : 12,
        name : "Gimesto",
        img : require('../assets/images/wireframe (8).png'),
        screenShots : [
            require('../assets/images/screens/gimesto (1).PNG'),
            require('../assets/images/screens/gimesto (2).PNG'),
            require('../assets/images/screens/gimesto (3).PNG'),
            require('../assets/images/screens/gimesto (4).PNG'),
            require('../assets/images/screens/gimesto (5).PNG')
        ],
        description : {
            theme : 'App store website',
            target : 'Freelance',
            techno : 'Html - Css - Js ',
            duration : '7 Days'
        }
    },
    {
        id : 13,
        name : "Se'ha",
        img : require('../assets/images/wireframe (9).png'),
        screenShots : [
            require('../assets/images/screens/seha (1).PNG'),
            require('../assets/images/screens/seha (2).PNG'),
            require('../assets/images/screens/seha (3).PNG'),
            require('../assets/images/screens/seha (4).PNG'),
            require('../assets/images/screens/seha (5).PNG')
        ],
        description : {
            theme : 'Gym exercises web app',
            target : 'Personal',
            techno : 'React Js - Sass',
            duration : '5 Days'
        }
    },
    {
        id : 14,
        name : "Mozikos",
        img : require('../assets/images/wireframe (10).png'),
        screenShots : [
            require('../assets/images/screens/mozikos (1).PNG'),
            require('../assets/images/screens/mozikos (2).PNG'),
            require('../assets/images/screens/mozikos (3).PNG'),
            require('../assets/images/screens/mozikos (4).PNG'),
            require('../assets/images/screens/mozikos (5).PNG')
        ],
        description : {
            theme : 'Moderne Spotify clone website.',
            target : 'Personal',
            techno : 'React Js - Sass',
            duration : '7 Days'
        }
    },
    {
        id : 15,
        name : "Memory Cards",
        img : require('../assets/images/wireframe (11).png'),
        screenShots : [
            require('../assets/images/screens/memorycard (1).PNG'),
            require('../assets/images/screens/memorycard (2).PNG'),
            require('../assets/images/screens/memorycard (3).PNG'),
            require('../assets/images/screens/memorycard (4).PNG'),
            require('../assets/images/screens/memorycard (5).PNG')
        ],
        description : {
            theme : 'Memory cards game',
            target : 'Personal',
            techno : 'Html - Css - Js',
            duration : '5 Days'
        }
    },
    {
        id : 16,
        name : "Tic Tac Toe",
        img : require('../assets/images/wireframe (12).png'),
        screenShots : [
            require('../assets/images/screens/xo (1).PNG'),
            require('../assets/images/screens/xo (2).PNG'),
            require('../assets/images/screens/xo (3).PNG'),
            require('../assets/images/screens/xo (4).PNG'),
            require('../assets/images/screens/xo (5).PNG')
        ],
        description : {
            theme : 'Tic Tac Toe game',
            target : 'Personal',
            techno : 'Html - Css - Js',
            duration : '5 Days'
        }
    },
    {
        id : 17,
        name : "Finito",
        img : require('../assets/images/wireframe (13).png'),
        screenShots : [
            require('../assets/images/screens/finisio (1).PNG'),
            require('../assets/images/screens/finisio (2).PNG'),
            require('../assets/images/screens/finisio (3).PNG'),
            require('../assets/images/screens/finisio (4).PNG'),
            require('../assets/images/screens/finisio (5).PNG')
        ],
        description : {
            theme : 'Space Invaders clone game',
            target : 'Personal',
            techno : 'Html - Css - Js',
            duration : '7 Days'
        }
    }
]